export default () => ({
  isRenderCheckffuid: false, // 是否展示FF校验的UID组件
  checkffuid: '', // FF的两个游戏需要输入的UID
  discountMoney: 0, // 优惠券最大折扣价格
  paymentChannel: [], // 支付通道列表
  selectChannelItem: {},
  serverList: [],
  selectServerItem: {},
  selectSkuItem: {},
  selectOuterSkuItem: {}, // 外部的SKU
  nickName: '',
  userId: '',
  serverUserId: {
    value: '',
    t: Date.now(), // 解决每次输入相同的可以watch能监听到
  }, // pns\3d
  serverId: '', // zoneid 、serverId 都存储到这个里面
  publicSkuList: null, // 分类的SKU && 普通的SKU 统一维护
  payList: [], // 接口配置默认的支付通道
  couponData: [], // 查询当前套餐可用的优惠券列表
  selectGokSkuids: [], // GOK游戏校验UID的时候，返回skuid ,前端通过SKU列表进行过滤显示
  accountId: '', // 账户ID，有的CP在提交订单的时候会使用，例如：【kungfu-legend】
  userRoles: {}, // 选择UID的时候、出现多角色信息
  isTipsOpen: false, // 解决 当server的组件和Tips组件同时展开冲突
  _isVpns: -1, // warn 临时为VPN添加、下期重构
  detailBasicConfig: {}, // 详情页基础配置信息
  tuneUpLogin: {
    // 直接调起登录功能
    type: '',
    option: {},
  },
  isSaveCoupon: false, // 是否保存了优惠券,默认为false
  coupons: {}, // 新版全部优惠券数据【可用\不可用】全部接口数据
  isUidFocus: -1, // 在PC端、点击提交按钮需要聚焦到uid区域、value值最好为时间戳[Date.now()]
  couponUplogin: false, // 调起优惠劵的登录弹层
  submitCloudControl: {}, // 应急云控、submit点击的传递参数
  submitClickStatus: {
    type: 'loading', // 点击提交的时候监听当前属性、是否提交订单； error 、success
    time: 0, // 每次点击都更新
  }, // 点击提交的时候监听当前属性、是否提交订单； error 、success
  calfinalPrice: 0, // warn 新版优惠券融合逻辑、存储优惠券后的价格
  isPierceLogoLayer: -1, // warn 直接调用loginBtn的登录弹层方法
  _noReloadPage: false, // warn  兼容APP环境是否刷新页面的问题@郭欣
  loadingBySkuChannels: {}, // 记录sku 对应的 sku-channel 接口的 loading 状态
  isRender900Nav: false, // 在新版的PC端、>=900 左侧明细显示隐藏
  toggleCouponLoging: false, // 切换优惠券加载的状态
  couponDiscountMoney: 0, // 选中优惠券的折扣价格
  uidValidator: {
    // UID的校验状态
    isInInput: false, // 是否在输入中
    isError: false, // 验证错误
    isSuccess: false, // 验证成功
    isLoading: false, // 验证中
    isZidError: false, // ZOOID错误「MLBB特有」
    errorCode: 0,
    showIcon: true,
  },
  submitButtonState: false, // 提交按钮是否可以点击
  ikCpServerId: '', //infinity-kingdom 下单使用【单独】
  exeOrderMethod: -1, // 执行下单的方法、[PC响应式] value值最好为时间戳[Date.now()]
  // 点击banner触发 「运营弹层」
  operateLayer: {
    t: Date.now(),
    popupId: '',
  },
  ssrConfig: {},
  payStatus: 'pending', // 解决切换SKU获取支付通道的时候延迟 pending\done
  // warn 解决、CODE\API-CODE模式、点击下单登录完成直接跳转下单的逻辑
  // 因为 优惠券计算依赖两个接口有延迟、需要捕获状态
  createCouponrState: {
    isCoupon: 'pending', // 当前是否有优惠券 success\error\pending
    isCompute: 'pending', // 选中的优惠券是否参与计算获取折扣 success\error\pending
  },
  // 是否显示<Discount>组件
  isShowDiscount: false,
  ssrAllData: [], // 详情SSR「服务器全部数据」
  notificationEmail: '', //用户设置的接收通知邮箱，是用户输入的内容，使用前需要校验邮箱格式
})
